<template>
    <div class="relation-material-wrap"
         id="relationWrap"
         ref="relationWrap"
         v-if="isFirstCreate && !loading && materialList.length"
    >
        <div class="relation-material-header">
            <span class="title">Related Reports</span>
        </div>
        <div class="relation-material-container" v-infinite-scroll="getList" ref="relationElTabs">
            <div
                    v-for="(_item,_index) in materialList"
                    :key="_index"
                    @click="gotoUrl(_item)"
                    class="report-item">
                <el-image :src="changeThumb(_item.imageUrl,61,83)" fit="cover" class="img"></el-image>
                <div>
                    <div class="item-title overflow-hidden-2"
                         :title="_item.name"
                    >
                        <span v-for="(name) in _item.name" :key="name">{{name}}</span>
                    </div>
                    <!-- <div><p class="overflow-hidden-1">{{_item.sourceAsMap.catName}}</p></div> -->
                </div>
            </div>
        </div>
    </div>
    <div v-else-if="isFirstCreate && !materialList.length && !loading"
         v-loading="isFirstCreate && !materialList.length && !loading"
         element-loading-text="no data"
         element-loading-spinner="none"
         element-loading-background="rgba(255, 255, 255, 0.8)"
         class="relation-material-wrap loading-nodata"></div>
    <div v-else-if="loading"
         v-loading="loading"
         class="relation-material-wrap"></div>
</template>

<script>
import * as _ from 'lodash'
import isSpecial from '../mixins/windowMedia'

export default {
  name: 'relationMaterial',
  data () {
    return {
      isFirstCreate: false,
      baseUrl: 'http://192.168.4.31/', // 路径
      dom: null,
      copies: isSpecial ? 4 : 6,
      loading: true,
      elTab: null,
      elTabWidth: 0
    }
  },
  props: {
    materialList: Array,
    page: Number
  },
  watch: {
    'materialList': {
      handler (value) {
        if (!this.isFirstCreate) {
          this.isFirstCreate = true
        }
      },
      deep: true
    },
    'loading' (newVal) {
      if (!newVal) {
        this.$nextTick(() => {
          this.$refs.relationWrap && (this.dom = this.$refs.relationWrap.children[1])
          this.$refs.relationElTabs && (this.elTab = this.$refs.relationElTabs)
        })
      }
    }
  },
  methods: {
    changeThumb (url, w, h) {
      let ext = url.split('.')
      let ret
      if ((url.indexOf('https://img.imsilkroad.com/a/thumb/') == -1 && url.indexOf('https://img.imsilkroad.com/a/') >= 0)) {
        ret = url.replace('com/a/', 'com/a/thumb/') + '!w' + w + '_h' + h + '.' + ext.pop()
        return ret
      } else if (url.indexOf('https://img.imsilkroad.com/a/thumb/') >= 0) {
        ret = url.replace(/w[0-9]*_/, 'w' + w + '_').replace(/_h[0-9]*/, '_h' + h)
        return ret
      }
      return url
    },
    getNavWidth () {
      this.elTabWidth = this.elTab.$refs.nav.$refs.navScroll.clientWidth
    },
    getList () {
      let page = this.page + 1
      this.$emit('changePage', page++)
    },
    changeList () {
      this.$emit('changeList')
    },
    gotoUrl (val) {
      this.$emit('gotoUrl', val)
    }
  }
}

</script>

<style scoped lang="less">
    @media screen and (min-width: 769px) and (max-width: 1199px) {
        .report {
            width: 50% !important;
        }
    }

    .relation-material-wrap {
        box-sizing: border-box;
        padding: 10px 16px;
        position: relative;
        background: #ffffff;

        .relation-material-header {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding-bottom: 13px;

            .title {
                color: #303133;
                padding: 0px;
                font-size: 16px;
                font-weight: bolder;
                line-height: 18px;
            }

            .change-button {
                cursor: pointer;
                color: #6C757D;

                i {
                    margin-right: 5px;
                }
            }
        }

        .relation-material-container {
            width: 100%;
            height: calc(100% - 50px);
            display: flex;
            flex-wrap: wrap;
            overflow-x: hidden;
            overflow-y: auto;

            .report-item {
                display: flex;
                width: 46%;
                padding: 10px 0;
                border-bottom: 1px solid #F2F6FC;
                cursor: pointer;

                &:hover {
                    .item-title {
                        color: #208EFF;
                    }
                }

                &:nth-child(2n-1) {
                    margin-right: 6%;
                }

                .item-title {
                    color: #6C757D;
                    font-weight: bold;
                    word-break: break-all;
                }

                .img {
                    flex-shrink: 0;
                    width: 61px;
                    height: 83px;
                    margin-right: 6px;
                }

                .overflow-hidden-2 {
                    overflow: hidden !important;
                    text-overflow: ellipsis !important;
                    display: -webkit-box !important;
                    -webkit-line-clamp: 2 !important;
                    -webkit-box-orient: vertical !important;
                }

                .overflow-hidden-1 {
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }

            /deep/ .el-tabs__header {
                margin: 0 !important;

                .el-tabs__nav-wrap {
                    > span {
                        top: 50%;
                        transform: translateY(-50%);
                    }

                    &::after {
                        position: static;
                    }
                }

                .el-tabs__item {
                    height: auto;
                    padding: 0 5px;
                    color: #303133 !important;

                    &:hover {
                        color: #303133 !important;
                    }
                }

                .el-tabs__active-bar {
                    display: none;
                }

                /*.is-top {*/
                /*  display: none;*/
                /*}*/
            }

            /*&::-webkit-scrollbar {*/
            /*  height: 4px;*/
            /*  !*height: 4px;*!*/
            /*}*/

            /*&::-webkit-scrollbar-button {*/
            /*  display: none;*/
            /*}*/

            .material-list {
                /*width: calc(50% - 15px);*/
                display: flex;
                flex-direction: column;
                align-items: center;
                flex-wrap: wrap;
                cursor: pointer;

                .report {
                    width: 33%;
                    height: 45%;
                    padding: 4px 8px;
                    cursor: pointer;
                }

                p {
                    margin: 0 !important;
                }

                .title-content {
                    height: 40px;
                    overflow: hidden;
                }

                .title {
                    width: 100%;
                    height: 38px;
                    line-height: 17px;
                    margin-top: 0 !important;
                    padding-top: 0 !important;
                    white-space: initial;
                    overflow: hidden !important;
                    text-overflow: ellipsis !important;
                    display: -webkit-box !important;
                    -webkit-line-clamp: 2 !important;
                    -webkit-box-orient: vertical !important;
                }

                .img {
                    width: 100%;
                    height: calc(100% - 70px);
                    object-fit: contain;
                    /*transform: scale(0.6) translateY(-50%);*/
                }
            }
        }
    }

    /deep/ .el-loading-mask {
        z-index: 900 !important;
    }

    /deep/ .el-loading-text {
        font-size: 14px !important;
        color: rgb(153, 153, 153) !important;
    }

    .loading-nodata {

        /deep/ svg {
            display: none;
        }
    }
</style>
